/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Table_TitleInputs */

const en_directory_external_directories_table_title = /** @type {(inputs: Directory_External_Directories_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The catalog`)
};

const zh_directory_external_directories_table_title = /** @type {(inputs: Directory_External_Directories_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录清单`)
};

/**
* | output |
* | --- |
* | "The catalog" |
*
* @param {Directory_External_Directories_Table_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_table_title = /** @type {((inputs?: Directory_External_Directories_Table_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Table_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_table_title(inputs)
	return zh_directory_external_directories_table_title(inputs)
});
export { directory_external_directories_table_title as "directory.external_directories.table_title" }